module.exports = "/_next/static/images/6339b22f8e3271f4b16cd0c95feeb155-man-holding-two-phones@1x.jpg";